import { useEffect } from 'react'
import { getSocket } from '@client/socket/socket'

type UseSidebarInvalidationArgs = {
    tables: string[] // e.g. ['user'] or ['project']
    actions?: Array<'updated' | 'deleted'> // optional filter
    refetch: () => void
}

export default function useSidebarInvalidation({ tables, actions, refetch }: UseSidebarInvalidationArgs) {
    useEffect(() => {
        const s = getSocket()

        const onChanged = (p: any) => {
            console.log(p)
            if (!p?.table) return
            if (!tables.includes(p.table)) return
            if (actions?.length && !actions.includes(p.action)) return
            refetch()
        }

        s.on('resource:changed', onChanged)
        return () => {
            s.off('resource:changed', onChanged)
        }
    }, [tables.join('|'), actions?.join('|') || '', refetch])
}
